<template>
    <el-row class="screen-make-picture" :gutter="20" type="flex">
        <el-col :span="6" class="makePicture-item create-makePicture">
            <upload class="makePicture-upload" :tip="$t('xian_zhi_fen_bian_lv_can_kao_ji_xing_fen_bian_lv_shou_ce')" :accept="'image/*'"
            :uploadSuccess="uploadSuccess"></upload>
        </el-col>
        <el-col :span="6" v-for="(item, index) in pictures" :key="index">
            <div class="makePicture-item">
                <img :src="item.url" @click="showPicture(item)"/>
                <p class="makePicture-item-text-info" @click="editLogo(item)">
                    <span>{{$t('bian_ji')}}</span>
                </p>
            </div>
        </el-col>
        <el-image-viewer
                v-if="pictureViewerVisible"
                :url-list="url"
                :on-close="closeViewer"/>
    </el-row>

</template>

<script>
    import Upload from '@/components/Upload'
    import ElImageViewer from "../../../../../node_modules/element-ui/packages/image/src/image-viewer";
    import {makePictureCreate, makePictureList} from '@/api/delivery/device/makePicture'
    export default {
        name: '',
        components: {
            ElImageViewer,
            Upload
        },
        mounted: function () {
            this.loadLogos()
        },
        data: function () {
            return {
                uploadVisible: false,
                pictureViewerVisible: false,
                url: [],
                pictures: [],
            }
        },
        methods: {
            closeViewer() {
                this.pictureViewerVisible = false
            },
            showPicture(item){
                let data = []
                data.push(item.url)
                this.url = data
                this.pictureViewerVisible = true
            },
            loadLogos() {
                makePictureList().then(res => {
                    this.pictures = res.data || []
                })
            },
            editLogo(item){
                this.$router.push({name: 'delivery.devices.screenManager.makePicture.detail', params: item})
            },
            uploadSuccess(url){
               let makePicture = {
                   url : url,
               }

                makePictureCreate(makePicture).then(res => {
                    makePicture.uuid = res.data
                    this.$message.success(this.$t('shang_chuan_cheng_gong'))
                    this.pictures.unshift(makePicture)
                })
            }
        },
    }
</script>

<style lang="scss">
    .screen-make-picture {
        margin-bottom: $padding;
        flex-flow: row wrap;
        align-content: flex-start;
        .makePicture-item {
            background-color: $bg_sec_color;
            border: .2rem;
            margin-bottom: $padding;
            img {
                width: 100%;
                height: 100%;
                cursor: pointer;
            }
            .makePicture-item-text-info {
                padding: $padding-5;
                font-size: .6rem;
                color: $f_sec_color;
                text-align: center;
                span {
                    cursor: pointer;
                }
                span:hover {
                    color: $f_color;
                }
                .look-devices {
                    margin-left: $padding-5;
                    display: inline-block;
                }
            }
        }

        .create-makePicture {
            background-color: transparent;
            .makePicture-upload {
                height: 100%;
                width: 100%;
            }
        }

    }
</style>
